import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Conversation } from '../../services/conversation';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatListModule,  } from '@angular/material/list';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardHeader, MatCardModule, MatCardTitle } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatTab,MatTabGroup} from '@angular/material/tabs'
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { environment } from '../../../environments/environment';
import { MatDialog,MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfirmDialogComponent } from './confirm-dialog';
import { AuthService } from '../../services/auth';




@Component({
  selector: 'app-conversation-messages',
  imports: [CommonModule,MatListModule,MatProgressSpinnerModule,MatCardModule,MatIconModule,
    MatCardHeader, MatCardTitle, MatToolbarRow, MatInput, FormsModule, MatLabel, MatFormField,MatOption,
     MatIcon,MatSelectModule, MatProgressSpinner, MatTab,MatTabGroup,MatDialogActions, MatDialogContent,
     MatSlideToggle
  ],
  templateUrl: './conversation-messages.html',
  styleUrl: './conversation-messages.scss',
  standalone: true
})
export class ConversationMessages {
  messages$!: Observable<any[]>;
  conversationId!: string;
  isLoading = false;

    // NEW — for date tabs
  dateGroups: any[] = [];
  selectedDateIndex = 0;
  loadingMessages = true;
  private messagesSub?: Subscription;
  private hasSetInitialDateIndex = false;

  templates = [
    {
      name: 'Loan Reminder',
      value:'loan',
      content: 'Hi {{name}}, your loan of {{amount}} is due on {{due_date}}.',
      variables: ['name', 'amount', 'due_date']
    },
    {
      name: 'Payment Confirmation',
      value:'confirmation',
      content: 'Hello {{name}}, we have received your payment of {{amount}} on {{date}}. Thank you!',
      variables: ['name', 'amount', 'date']
    },
    {
      name: 'Welcome Message',
      value:'welcome',
      content: 'Hi {{name}}, welcome to BainesCredit! We’re glad to have you.',
      variables: ['name']
    },
    {
      name: 'Issue Resolution',
      value: 'issue_resolution',
      content: 'Hi {{name}}, your {{issue}} has ben resolved. Thanks for using BainesCredit.',
      variables: ['name','issue']
    }
  ];

  selectedTemplate: any = null;
  templateValues: { [key: string]: string } = {};

  freeformMessage: string = '';
  isSendingFreeform: boolean = false; 
  selectedTabIndex;
  humanAgent;
  user;
  send_msgs;
  phoneNumberId;



  constructor(
    private route: ActivatedRoute,
    private conversationService: Conversation,
    private router: Router,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.conversationId = this.route.snapshot.paramMap.get('id')!;
    this.messages$ = this.conversationService.getMessages(this.conversationId);

    this.messagesSub = this.messages$.subscribe(groups => {
      this.dateGroups = groups || [];
      this.loadingMessages = false;

      if (!this.hasSetInitialDateIndex && this.dateGroups.length) {
        // this.selectedDateIndex = this.dateGroups.length - 1; // land on most recent date
        this.hasSetInitialDateIndex = true;
      }
    });


    this.conversationService._templates.subscribe(templates=>{
      if(templates){
        this.templates = templates
      }
    })

    this.conversationService.getConversationState(this.conversationId).subscribe(state=>{
      if(state){
        // console.log(state['humanAgent'])
        if(state['humanAgent']){
          this.humanAgent = state['humanAgent'];
          console.log(this.humanAgent)
        }
        // console.log('states:',state)
        this.phoneNumberId = state['phoneNumberId']||'876513755536442'
      }
    })
    this.authService.user$.subscribe(async user=>{
    if(user){
      this.user = user;
      // console.log(this.user.email)
      const tokenResult = await this.user.getIdTokenResult();
     const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
     this.send_msgs = tokenResult.claims.send_msgs === true||tokenResult.claims.admin === true;
      if (!allowView) {
        this.router.navigate(['/conversation']);
      }
    }
   })
  }

  ngOnDestroy(): void {
    this.messagesSub?.unsubscribe();
    }

  goBack(): void {
    console.log('Navigating back to conversation list');
    this.router.navigate(['/']);
  }

  sanitizeHtml(content: string): SafeHtml {
    // Automatically detect URLs and wrap them in <a> tags
    const htmlWithLinks = content.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    return this.sanitizer.bypassSecurityTrustHtml(htmlWithLinks);
  }


  // sendTemplateMessage() {
  //   const message = this.getPreviewMessage();
  //   console.log('Sending message:', message);
  //   // Add your Firestore/WhatsApp API send logic here
  // }

     onTemplateChange(template: any) {
    this.templateValues = {};
    template.variables.forEach((v: string) => (this.templateValues[v] = ''));
  }

  getPreviewMessage(): string {
    if (!this.selectedTemplate) return '';
    let msg = this.selectedTemplate.content;
    for (const [key, val] of Object.entries(this.templateValues)) {
      msg = msg.replace(`{{${key}}}`, val || `{{${key}}}`);
    }
    return msg;
  }

  sendTemplateMessage() {
  const message = this.getPreviewMessage();

  // Build the variables array (key-value pairs)
  const variablesArray = Object.entries(this.templateValues).map(([key, value]) => ({
    name:key,
    value
  }));

  // Create the structured object
  const templatePayload = {
    templateName: this.selectedTemplate?.value || '',
    generatedMessage: message,
    variables: variablesArray,
    timestamp: new Date().toISOString(),
    phoneNumber:this.conversationId,
    message,
    role:'assistant',
    lng:'en',
    user:{email:this.user.email},
    phoneNumberId:this.phoneNumberId
  };

  // console.log('🟢 Template Payload:', templatePayload);

  // TODO: Replace this with Firestore/WhatsApp API send logic
  // Example: this.messageService.sendTemplate(templatePayload);

   this.conversationService.postMessage(templatePayload, environment.endpoints.SEND_TEMPLATE) // Adjust 'messages' if needed
    .then(() => {
      console.log('Message sent successfully!');
      // this.global.showAlert('Message sent successfully',"Success");
      // Success: Clear input and re-enable button
      this.isLoading = false; 
      ;
    })
    .catch(error => {
      console.error('Error sending message:', error);
      this.isLoading = false; // Re-enable button even on error
      // this.global.showAlert(error.error.msg,error.error.title);

      // Handle the error, e.g., display an error message to the user
    });

  return templatePayload;
}



  sendMessage() {

  
  this.isSendingFreeform = true;

  // Create the structured object
  const templatePayload = {
    timestamp: new Date().toISOString(),
    phoneNumber:this.conversationId,
    message:this.freeformMessage,
    role:'assistant',
     user:{email:this.user.email},
     phoneNumberId:this.phoneNumberId
  };

  // console.log('🟢 Freeform Payload:', templatePayload);

  // TODO: Replace this with Firestore/WhatsApp API send logic
  // Example: this.messageService.sendTemplate(templatePayload);

  if (this.freeformMessage?.trim()){
  this.conversationService.postMessage(templatePayload, environment.endpoints.SEND_MSG) // Adjust 'messages' if needed
    .then(() => {
      console.log('Message sent successfully!');
      // this.global.showAlert('Message sent successfully',"Success");
      // Success: Clear input and re-enable button
      this.isLoading = false; 
      this.freeformMessage = null;
      this.isSendingFreeform = false;
      ;
    })
    .catch(error => {
      console.error('Error sending message:', error);
       this.isSendingFreeform = false;
      this.isLoading = false; // Re-enable button even on error
      // this.global.showAlert(error.error.msg,error.error.title);

      // Handle the error, e.g., display an error message to the user
    });
  }

 

  return templatePayload;
}

 onToggleHumanAgent(event: MatSlideToggleChange) {
    const newValue = event.checked;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      data: {
        title: 'Confirm Action',
        message: newValue
          ? 'Are you sure you want to disable AI agent responses?'
          : 'Re-enable AI agent responses?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.humanAgent = newValue;
        this.toggleHumanAgent(); // call your already defined function
      } else {
        // revert toggle if user cancels
        this.humanAgent = !newValue;
      }
    });
  }

   toggleHumanAgent() {
    // your existing function logic to update Firestore, etc.
    console.log('Human agent mode:', this.humanAgent);
    const updates = {
      humanAgent:this.humanAgent
    }

    let payload = {
      phoneNumber: this.conversationId,
      updates:updates
    }

      this.conversationService.postMessage(payload, environment.endpoints.UPDATE_STATE) // Adjust 'messages' if needed
    .then(() => {
      console.log('Message sent successfully!');
      // this.global.showAlert('Message sent successfully',"Success");
      // Success: Clear input and re-enable button
      this.isLoading = false; 
      
      ;
    })
    .catch(error => {
      console.error('Error sending message:', error);
      this.isLoading = false; // Re-enable button even on error
      // this.global.showAlert(error.error.msg,error.error.title);

      // Handle the error, e.g., display an error message to the user
    });
  }


}
